var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "circle-star 1",
    clipPath: "url(#clip0_1003_1664)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M19.1625 11.65L24.225 12.3813C24.6063 12.4375 24.9188 12.7 25.0375 13.0625C25.15 13.425 25.0562 13.825 24.7812 14.0875L21.1187 17.6625L21.9813 22.7062C22.0438 23.0812 21.8937 23.4625 21.5812 23.6313C21.275 23.9125 20.8687 23.9375 20.5312 23.7625L16 21.3813L11.4688 23.7625C11.1313 23.9375 10.725 23.9125 10.4187 23.6313C10.1062 23.4625 9.95625 23.0812 10.0188 22.7062L10.8813 17.6625L7.21875 14.0875C6.94375 13.825 6.85 13.425 6.9625 13.0625C7.08125 12.7 7.39375 12.4375 7.775 12.3813L12.8375 11.65L15.1062 7.05625C15.2688 6.71875 15.6187 6.5 16 6.5C16.3813 6.5 16.7312 6.71875 16.8937 7.05625L19.1625 11.65ZM13.6438 13.55L10.0625 14.0688L12.6562 16.6C12.8938 16.825 12.9438 17.1562 12.9438 17.4813L12.3313 21.05L15.5375 19.3625C15.825 19.2125 16.175 19.2125 16.4625 19.3625L19.6688 21.05L19.0562 17.4813C19 17.1562 19.1063 16.825 19.3438 16.6L21.8813 14.0688L18.3563 13.55C18.0312 13.5063 17.6938 13.3 17.6 13.0063L15.9438 9.7625L14.4 13.0063C14.25 13.3 13.9688 13.5063 13.6438 13.55ZM32 16C32 24.8375 24.8375 32 16 32C7.1625 32 0 24.8375 0 16C0 7.1625 7.1625 0 16 0C24.8375 0 32 7.1625 32 16ZM16 2C8.26875 2 2 8.26875 2 16C2 23.7313 8.26875 30 16 30C23.7313 30 30 23.7313 30 16C30 8.26875 23.7313 2 16 2Z",
    fill: "#757575"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1003_1664"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.4165ec7b555284b85e6a7e5eabf966bc.svg";
export { ForwardRef as ReactComponent };